// ************************************
// this is the Franchise Contact Form Thank You Page
// ************************************

import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { Section } from '../../../components';
import { PageType } from '../../../global';
import BaseLayout from '../../../layouts/Base';
import { H2, P, media } from '../../../global';

const MessageWrapper = styled.div`
  max-width: 700px;
  margin: 0 auto;
  background: #fff;
  padding: 50px;
  border: 1px solid #e0e0e0;
  text-align: center;

  ${media.down.md`
    padding: 30px;
  `}
`;

const ThankYouTitle = styled(H2)`
  color: ${p => p.theme.color.avocado};
  margin-bottom: 25px;
`;

const ThankYouText = styled(P)`
  margin-bottom: 20px;
  line-height: 1.8;
  font-size: 18px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const ContactFormThankYou = ({
  franchisingFooter,
  franchisingHeader,
  ...layoutProps
}) => {
  return (
    <BaseLayout
      {...layoutProps}
      franchisingFooter={franchisingFooter}
      franchisingHeader={franchisingHeader}
    >
      <Section dividerBottomColor="tan" dividerBottomReverse>
        <MessageWrapper>
          <ThankYouTitle>We've Received Your Inquiry</ThankYouTitle>
          <ThankYouText>
            Your franchise inquiry has been successfully submitted.
          </ThankYouText>
          <ThankYouText>
            A member of our franchising team will review your information and 
            reach out to you shortly to discuss the next steps.
          </ThankYouText>
          <ThankYouText>
            We appreciate your interest in joining the Salata family!
          </ThankYouText>
        </MessageWrapper>
      </Section>
      {/* Franchising.com Conversion Tracking */}
      <img 
        src="//www.franchising.com/n/l_salata.gif" 
        width="1" 
        height="1" 
        border="0" 
        alt="" 
        style={{ position: 'absolute', visibility: 'hidden' }}
      />
    </BaseLayout>
  );
};

ContactFormThankYou.propTypes = {
  ...PageType
};

export default ContactFormThankYou;
